import { render, staticRenderFns } from "./complaintsInfo.vue?vue&type=template&id=ce225e68&scoped=true&"
import script from "./complaintsInfo.vue?vue&type=script&lang=js&"
export * from "./complaintsInfo.vue?vue&type=script&lang=js&"
import style0 from "./complaintsInfo.vue?vue&type=style&index=0&id=ce225e68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce225e68",
  null
  
)

export default component.exports